import React, { useCallback, useEffect, useRef, useState } from "react";
import { fetchLegalHtml, fetchPublicLegalDocument, TERMS_DOCUMENT_ID } from "../../lib/legalGraphql";
import "./TermsPanel.css";

const SCROLL_THRESHOLD = 8;

export default function TermsPanel({
  readUrl: readUrlProp,
  version: versionProp,
  onScrollComplete,
  onReady,
}) {
  const scrollRef = useRef(null);
  const [html, setHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [scrollComplete, setScrollComplete] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setLoading(true);
      setError("");
      try {
        let readUrl = readUrlProp;
        if (!readUrl) {
          const meta = await fetchPublicLegalDocument(TERMS_DOCUMENT_ID);
          if (!meta?.read_url) {
            throw new Error("Términos y Condiciones no disponibles todavía.");
          }
          readUrl = meta.read_url;
          onReady?.(meta);
        }
        const text = await fetchLegalHtml(readUrl);
        if (!cancelled) {
          setHtml(text);
        }
      } catch (e) {
        if (!cancelled) setError(e.message || "Error al cargar T&C");
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [readUrlProp, onReady]);

  const checkScroll = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    const atBottom =
      el.scrollHeight - el.scrollTop - el.clientHeight <= SCROLL_THRESHOLD;
    if (atBottom && !scrollComplete) {
      setScrollComplete(true);
      onScrollComplete?.(true);
    }
  }, [scrollComplete, onScrollComplete]);

  useEffect(() => {
    checkScroll();
  }, [html, checkScroll]);

  if (loading) {
    return <p className="terms-panel-loading">Cargando Términos y Condiciones…</p>;
  }

  if (error) {
    return <p className="terms-panel-error">{error}</p>;
  }

  return (
    <div className="terms-panel">
      <div className="terms-panel-header">
        <span>Términos y Condiciones</span>
        {versionProp ? <span className="terms-panel-version">v{versionProp}</span> : null}
      </div>
      <div
        className="terms-panel-scroll"
        ref={scrollRef}
        onScroll={checkScroll}
        aria-label="Términos y Condiciones"
      >
        <div
          className="terms-panel-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
      {!scrollComplete && (
        <p className="terms-panel-hint">Desplazate hasta el final para continuar</p>
      )}
    </div>
  );
}
